import baseRoute from '../../fieldReport/baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/reports/virtual/${string | ':code'}/download/${number | ':subjobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/reports/virtual/:code/download/:subjobId`;

export const URL = (code: string, subjobId: number): RouteDefinition => `${baseRoute}/reports/virtual/${code}/download/${subjobId}`;
